import React from "react";
import { Link } from "react-router-dom";

const Intro = () => {
  return (
    <div className=" bg-gray-900 pb-5">
      <h1 className="text-center pt-3 font-medium text-xl text-white ">
        What i do
      </h1>
      <div className="sm:grid sm:grid-cols-2 sm:gap-x-10 sm:mt-5 p-5">
        <div className="px-3 py-3 mb-4 lg:ml-28 sm:ml-10 bg-gray-700 rounded-lg shadow-lg">
          <h1 className=" text-xl text-gray-200 font-semibold mb-3">
            Hi i'm Pavan
          </h1>
          <h3 className="text-lg sm:text-xl font-semibold mb-3 text-gray-200">
            I am freelance software engineer specialized in both front-end and
            back-end.
          </h3>
          <h3 className="text-base text-gray-200  mb-3">
            <span className="text-lg text-green-300 font-semibold">
              Back-end:{" "}
            </span>
            SQL databases (MySQL, PostgreSQL), Node.js, NoSQL firebase
          </h3>
          <h3 className="text-base text-gray-200">
            <span className="text-lg font-semibold text-green-300">
              Front-end:{" "}
            </span>
            JavaScript, TypeScript, React (with Hooks) Redux, next.js. Led
            dozens of front-end codebases,
          </h3>
          <div className="flex justify-center mt-8">
            <Link to="/profile">
              <button className="border focus:outline-none border-gray-100 hover:bg-gray-200 hover:text-black text-base tracking-wider font-semibold text-white px-7 py-1">
                profile
              </button>
            </Link>
          </div>
        </div>
        <div className="lg:mr-28 sm:flex sm:justify-center px-3 py-3">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/1024px-Unofficial_JavaScript_logo_2.svg.png"
            alt="img"
            className="sm:h-52 md:h-60 lg:h-72 lg:ml-10 rounded-lg mb-4"
          />
        </div>
      </div>
    </div>
  );
};

export default Intro;
